var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGoToDemo = function SvgIconGoToDemo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 13.4167C2.46676 13.58 3.2018 13.9752 3.77967 14.5531C4.35753 15.1309 4.75271 15.866 4.91602 16.6667M1.66602 10.0417C3.35834 10.2299 4.93625 10.9884 6.14028 12.1924C7.34431 13.3965 8.1028 14.9744 8.29102 16.6667M1.66602 6.66671V5.00004C1.66602 4.55801 1.84161 4.13409 2.15417 3.82153C2.46673 3.50897 2.89065 3.33337 3.33268 3.33337H16.666C17.108 3.33337 17.532 3.50897 17.8445 3.82153C18.1571 4.13409 18.3327 4.55801 18.3327 5.00004V15C18.3327 15.4421 18.1571 15.866 17.8445 16.1786C17.532 16.4911 17.108 16.6667 16.666 16.6667H11.666",
    stroke: "#616A88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 16.6666H1.67435",
    stroke: "#616A88",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGoToDemo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-go-to-demo.3fe7d210.svg";
export { ForwardRef as ReactComponent };